<template>
  <v-data-table
    v-if="displayData"
    v-model="table_data"
    :headers="headers"
    :items="data"
    :items-per-page="5"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Preview Table</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
    <!-- Template for User Roles Menu -->
    <template v-slot:[`item.roles`]="{ item }">
      <role-selector :item="item" v-model="item.role" @input="selectRole" />
    </template>
    <!-- End of Template for User Roles Menu -->
  </v-data-table>
</template>
<script>
import { mapState } from "vuex";
import RoleSelector from "../users/UsersRoles.vue";
export default {
  props: {
    displayData: Boolean
  },
  components: {
    RoleSelector,
  },
  data() {
    return {
      selected_role:"",
      table_data: []
    };
  },
  computed: {
    ...mapState({
      headers: (state) => state.file_imports.headers,
      data: (state) => state.file_imports.data,
      action_for: (state) => state.file_imports.action_for,
    }),
  },
  methods:{
    update_user_data(){
      this.$store.dispatch('file_imports/set_user_data_with_roles',this.data)
    },
    update_offices_data(){
      this.$store.dispatch('file_imports/set_office_data',this.data)
    }
  },
  watch:{
    data:function(val){
      if(this.action_for ==  'user_imports')  this.$store.dispatch('file_imports/set_user_data_with_roles',val)
    },
    displayData(){
      if(!this.displayData)
        this.table_data = []
    }
  }
};
</script>
